import { render, staticRenderFns } from "./FlightTeaser.vue?vue&type=template&id=3111258a&lang=pug&"
import script from "./FlightTeaser.vue?vue&type=script&lang=js&"
export * from "./FlightTeaser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports